<script setup lang="ts">
interface Props {
  manufacturer?: Manufacturer
  supplier?: { handle: string }
  clinicChain: ProductClinicChain
  productName: string
  idExternal: string
  navigationPath?: string
}
const props = withDefaults(defineProps<Props>(), {})
const localePath = useLocalePath()
const supplierStore = useSupplier()
const isAlternativeProduct = inject<ComputedRef<boolean>>('isAlternativeSheet', computed(() => false))

const manufacturerLink = computed(() => {
  if (!props.manufacturer) return ''
  const isKnownSupplier = supplierStore.suppliers.some(s => s.handle === props.manufacturer!.handle)
  return isKnownSupplier
    ? `/supplier/${props.manufacturer.handle}`
    : `/search?m=${props.manufacturer.handle}`
})
</script>

<template>
  <div class="d-flex">
    <NuxtLink
      v-if="props.manufacturer"
      data-nav-id="product_manufacturer"
      class="text-decoration-none"
      :to="localePath(manufacturerLink)"
    >
      <p class="text-caption font-weight-bold text-vm-grey-7 my-0">
        {{ props.manufacturer.name }}
      </p>
    </NuxtLink>
    <p
      data-test-id="product-idExternal"
      :class="props.manufacturer ? 'text-caption text-vm-grey-7 my-0 ml-15' : 'text-caption text-vm-grey-7'"
    >
      {{ $t('searchResult.articleNumber') }}: {{ props.idExternal }}
    </p>
  </div>
  <h4 class="text-h5 font-weight-bold my-0 text-vm-black">
    <!-- Todo: add shop::display-product-details feature flag -->
    <NuxtLink
      v-if="navigationPath"
      :to="localePath(navigationPath)"
      data-nav-id="product_title_link"
      data-test-id="search-productDetail-link"
      class="text-decoration-none text-vm-black"
      :target="isAlternativeProduct ? '_blank' : undefined"
    >
      {{ props.productName }}
    </NuxtLink>
    <template v-else>
      {{ props.productName }}
    </template>
  </h4>
  <vmz-chip
    v-if="props.clinicChain"
    :to="localePath('/clinic-chain')"
    data-nav-id="product_clinic_chain"
    size="small"
    tag="nuxt-link"
    class="mt-1"
    :variant="props?.clinicChain?.color ? 'flat' : 'tonal'"
    :color="props?.clinicChain?.color"
  >
    {{ props.clinicChain.name }} {{ props.clinicChain?.group }}
  </vmz-chip>
</template>
